//Angular
import { Component, inject } from '@angular/core';

//Services
import { AppConfigService } from '@core/services/config/app-config.service';

//Pipes and interfaces
import { TranslatePipe } from 'src/app/core/pipe/translate.pipe';

//Other
import { Log } from '@core/services/config/app-config.service';

export interface Country {
    id: string,
    name: string,
    img: string,
    route: string
}

@Component({
    selector: 'app-domain-switcher',
    imports: [TranslatePipe],
    templateUrl: './domain-switcher.component.html',
    styleUrl: './domain-switcher.component.scss'
})

export class DomainSwitcherComponent {

    
    // ==========================================
    // SERVICES
    // ==========================================

    appConfig = inject(AppConfigService);

    // ==========================================
    // DATA PROPERTIES
    // ==========================================
    countries: Country[] = [
        this.createCountryConfig('IT', 'Italiano', 'it','ITA'),
        this.createCountryConfig('CO.UK', 'English (UK only)', 'co.uk', 'UK'), // flag diversa dall'id
        this.createCountryConfig('FR', 'Français', 'fr','FRA'),
        this.createCountryConfig('DE', 'Deutsch', 'de','GER'),
        this.createCountryConfig('ES', 'Español', 'es','SPA'),
        this.createCountryConfig('COM', 'English (World)', 'com', 'COM')
    ];


    // ==========================================
    // DATA LOADING METHODS
    // ==========================================

    private createCountryConfig(id: string, name: string, langCode: string, flagCode?: string) {
        return {
            id,
            name,
            img: `${this.appConfig.imagePathFlags()}${flagCode || id}.webp`,
            route: this.appConfig.webUrlLang(langCode)
        };
    }

}
